// extracted by mini-css-extract-plugin
export default {"DataField":"_DataField--I6hTq","DataFieldTooltip":"_DataFieldTooltip--gzzrK","DataFieldPlaceholder":"_DataFieldPlaceholder--bFjdv"};